const HONEYPOT_ID = 'htf-checkout-login-honeypot'
const MAX_ATTEMPTS = 16
const RETRY_DELAY_MS = 250

export default defineNuxtPlugin((nuxtApp) => {
  let retryHandle: number | null = null

  const clearRetry = () => {
    if (retryHandle) {
      window.clearTimeout(retryHandle)
      retryHandle = null
    }
  }

  const labelHoneypot = (attempt = 1) => {
    const honeypot = document.getElementById(HONEYPOT_ID)

    if (honeypot instanceof HTMLInputElement) {
      honeypot.setAttribute('aria-label', 'Leave this field empty')
      return
    }

    if (attempt >= MAX_ATTEMPTS) {
      return
    }

    clearRetry()
    retryHandle = window.setTimeout(
      () => labelHoneypot(attempt + 1),
      RETRY_DELAY_MS,
    )
  }

  nuxtApp.hook('app:mounted', () => labelHoneypot())
  nuxtApp.hook('page:finish', () => labelHoneypot())
})
